import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useResponsiveDrawEnabled = (iotDevice) => {
    const isGlobalResponsiveDraw = iotDeviceGlobalConfigService.isGlobalResponsiveDraw(iotDevice);
    const isFeatureResponsiveDraw = iotDeviceFeatureConfigService.isResponsiveDrawModeEnabled();

    const isResponsiveDrawEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalResponsiveDraw,
        isFeatureResponsiveDraw
    );

    return isResponsiveDrawEnabled;
};

export default useResponsiveDrawEnabled;
